module.exports = __webpack_public_path__ + "static/media/check.6ff74ce6.svg";